import React from 'react'
import { Platform } from 'react-native'

import { Icon } from '@zet/design-system/icons'
import { XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { H5 } from '@zet/design-system/typography'
import { BottomSheetHeaderProps } from '@zet/utils/interface'

import { useNavigation } from '@hooks/useNavigation'

export default function BottomSheetHeader({
  primaryIcon,
  secondaryIcon = 'Close',
  title,
  isSecondaryIcon = true,
  isGoBack = false,
  isPrimaryIconShadow = false,
  isHeaderShadow = false,
  eventName,
  eventPayload,
}: BottomSheetHeaderProps) {
  const navigation = useNavigation()
  const hanldeNavigation = () => {
    if (Platform.OS === 'web') {
      window.history.back()
      return true
    }
    navigation.canGoBack()
      ? navigation.goBack()
      : navigation.navigate('HomeView')
  }
  return (
    <XStack
      className={`items-center justify-between bg-white px-3 py-2 ${
        isHeaderShadow ? 'border-grays-30 border-b ' : ''
      }`}
    >
      <XStack className="items-center">
        <Pressable
          className={
            Platform.OS === 'web'
              ? isPrimaryIconShadow
                ? 'bg-grays-20 rounded p-2'
                : ' p-2'
              : isPrimaryIconShadow
              ? 'bg-grays-20 rounded p-[6]'
              : ' p-[6]'
          }
          onPress={isGoBack ? hanldeNavigation : () => false}
          eventName={eventName}
          eventPayload={eventPayload}
        >
          <Icon type={primaryIcon} size={24} />
        </Pressable>
        {title && <H5 className=" ml-[12] ">{title} </H5>}
      </XStack>
      {isSecondaryIcon && (
        <Pressable
          onPress={hanldeNavigation}
          eventName={eventName}
          eventPayload={eventPayload}
        >
          <Icon size={24} type={secondaryIcon} />
        </Pressable>
      )}
    </XStack>
  )
}
